import { z } from "zod";

import { AnalyzeCampaignRequestBodySchema } from "../../../schemas/analytics/analyze-campaign";
import { AnalyzeExperimentRequestBodySchema } from "../../../schemas/analytics/analyze-experiment";
import { AnalyzeSitewideRequestBodySchema } from "../../../schemas/analytics/analyze-sitewide";
import {
  AnalyticsResourceListSchema,
  DatasetIdList,
} from "../../../schemas/analytics/base";

export const AnalyzeResourceRequestBodySchema = z.discriminatedUnion(
  "resourceType",
  [
    AnalyzeExperimentRequestBodySchema,
    AnalyzeCampaignRequestBodySchema,
    AnalyzeSitewideRequestBodySchema,
  ]
);

export type AnalyzeResourceRequestBodyType = z.infer<
  typeof AnalyzeResourceRequestBodySchema
>;

export const AnalyzeResourceResponseBodySchema = z.object({
  datasetId: z.enum(DatasetIdList),
  resourceType: z.enum(AnalyticsResourceListSchema),
  metrics: z.any().array(),
  loss: z.any(),
  latestRunTs: z.number(),
});

export type AnalyzeResourceResponseBodyType = z.infer<
  typeof AnalyzeResourceResponseBodySchema
>;
